import React, { useContext, useState, useEffect } from "react";
import styles from "./TemplatePreview.module.css";
import { AiOutlineClose } from "react-icons/ai";
import { MdOutlineMessage } from "react-icons/md";
import { FaCheck, FaChevronDown, FaChevronUp, FaWhatsapp } from "react-icons/fa";
import TemplatePreviewWhatsApp from "./TemplatePreviewWhatsApp";
import ActiveStoreContext from "../../../store/ActiveStoreContext";
import AuthContext from "../../../store/auth-context";
import { useParams } from "react-router";
import { BASE_URL_API } from "../../../References/URLs";
import { toast } from "react-toastify";
import ContentSelector from "../Assets/ContentSelector";

const TemplatePreview = ({ visible, onClose, template, onTemplateSelect, data, setData }) => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext);
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const { campaignIdentifier } = useParams()
    const [previewText, setPreviewText] = useState("");
    const [selectedTemplate, setSelectedTemplate] = useState(template);
    const [errorMessage, setErrorMessage] = useState("");
    const [variables, setVariables] = useState([]);
    const [variableValues, setVariableValues] = useState({});
    const [footerVariables, setFooterVariables] = useState([])
    // console.log("variables : ", variables)
    // console.log("variables values : ", variableValues)
    // console.log("variables values : ", footerVariables)
    const [templateErrors, setTemplateErrors] = useState()
    const [isErrorOpen, setIsErrorOpen] = useState(false)
    const [isUpdatingFields, setIsUpdatingFields] = useState(false)
    const [isContentSelectorOpen, setIsContentSelectorOpen] = useState(false)

    const [headerData, setHeaderData] = useState({
        headerType: template?.headerType,
        headerContent: template?.headerContent,
    })

    const [predefinedParams, setPredefinedParams] = useState([
        { identifier: 'storeName', label: 'Store Name', value: activeStore?.storeName },
        { identifier: 'storeAddress', label: 'Store Address', value: activeStore?.storeAddress },
        { identifier: 'storePrimaryPhone', label: 'Primary Phone', value: activeStore?.storePrimaryPhone },
        { identifier: 'storeSecondaryPhone', label: 'Secondary Phone', value: activeStore?.storeSecondaryPhone },
        { identifier: 'storeTertiaryPhone', label: 'Tertiary Phone', value: activeStore?.storeTertiaryPhone },
        { identifier: 'mapLink', label: 'Map Link', value: activeStore?.mapLink }
    ])

    // Utility to extract variables from content like {{1}}, {{2}}
    const extractVariables = (template) => {
        if (!template || typeof template.content !== 'string') return [];
        const matches = template.content.match(/{{\d+}}/g);
        return Array.isArray(matches) ? [...new Set(matches)] : [];
    };

    // Utility to replace variables with values
    const generatePreviewText = (content, values) => {
        if (!content) return "";
        return content.replace(/{{\d+}}/g, (match) => values[match] || match);
    };




    // On template change
    useEffect(() => {
        const extracted = extractVariables(template);
        setVariables(extracted);

        const initialValues = {};
        extracted.forEach((v) => (initialValues[v] = ""));
        setVariableValues(initialValues);

        setPreviewText(generatePreviewText(template?.content, initialValues));
        setSelectedTemplate(template);
    }, [template]);

    // Handle input change
    const handleVariableChange = (variableKey, value) => {
        const updatedValues = { ...variableValues, [variableKey]: value };
        setVariableValues(updatedValues);
        setPreviewText(generatePreviewText(template?.content, updatedValues));
    };

    const handleFooterVariableChange = (variableKey, value) => {
        console.log(variableKey, value)
        const updatedValues = { ...footerVariables, [variableKey]: value };
        setFooterVariables(updatedValues)
    };

    function validateTemplateVars(input) {
        const errors = [];

        input.forEach(({ varType, position, value }, index) => {
            const isEmpty = value === "" || value === null || value === undefined;

            if (isEmpty) {
                errors.push({
                    error: `Missing value for ${varType} at position ${position}`,
                    index: index
                });
            }
        });

        if (errors.length > 0) {
            return {
                status: "error",
                message: "Some values are missing.",
                errors: errors
            };
        }

        return {
            status: "success",
            message: "All values are present."
        };
    }


    // Select Template handler
    const handleSelectTemplate = async () => {
        let varData = [
            { varType: 'header', position: 1, value: headerData?.headerContent }
        ];

        Object.entries(variableValues).forEach(([key, value]) => {
            const position = parseInt(key.replace(/[{}]/g, '')); // Extract number from {{1}}
            varData.push({ varType: 'body', position, value });
        });

        if (Object.entries(footerVariables)?.length > 0) {
            Object.entries(footerVariables).forEach(([key, value]) => {
                const position = parseInt(key); // Extract number from {{1}}
                varData.push({ varType: 'footer', position, value });
            });
        }

        if(validateTemplateVars(varData)?.status==="success") {
            const response = await fetch(BASE_URL_API+"selectTemplateForCampaign",
            {
                method : "POST",
                body : JSON.stringify({
                    token : authCtx.token,
                    campaignIdentifier : campaignIdentifier,
                    templateData : template
                })
            })
            if(!response.ok) {
                console.log("Something went wrong : Server Error")
            } else {
                const respo = await response.json()
                if(respo.status==="success") {
                    toast(`Successfully selected the template!`)
                    onTemplateSelect()
                    onClose()
                } else {
                    if(respo.message==="tokenExpired") {
                        authCtx.logout()
                    }
                }
                console.log(respo)
            }
        } else {
            toast.warn(`You must fill all the parameters!`)
        }


    };

    const handleOverlayClick = () => onClose();
    const handleContentClick = (e) => e.stopPropagation();

    const variableSelectorHandler = (p, k) => {
        handleVariableChange(p, activeStore[k])
    }

    const footerSelectorHandler = (p, v) => {
        handleFooterVariableChange(p, activeStore[v])
    }

    const submissionHandler = () => {
        let varData = [
            { varType: 'header', position: 1, value: headerData?.headerContent }
        ];

        Object.entries(variableValues).forEach(([key, value]) => {
            const position = parseInt(key.replace(/[{}]/g, '')); // Extract number from {{1}}
            varData.push({ varType: 'body', position, value });
        });

        if (Object.entries(footerVariables)?.length > 0) {
            Object.entries(footerVariables).forEach(([key, value]) => {
                const position = parseInt(key); // Extract number from {{1}}
                varData.push({ varType: 'footer', position, value });
            });
        }

        // console.log(template?.templateIdentifier, campaignIdentifier)
        // console.log(varData);

        const setTemplateVariableForCampaign = async () => {
            setIsUpdatingFields(true)
            const response = await fetch(BASE_URL_API + "setTemplateVariableForCampaign",
                {
                    method: "POST",
                    body: JSON.stringify({
                        token: authCtx.token,
                        campaignIdentifier: campaignIdentifier,
                        templateIdentifier: template?.templateIdentifier,
                        varData: varData
                    })
                })

            if (!response.ok) {
                console.log("Something went wrong : Server Error")
            } else {
                const respo = await response.json()
                if (respo.status === "success") {
                    toast(`Successfully updated the data!`)
                } else {
                    if (respo.message === "tokenExpired") {
                        authCtx.logout()
                    }

                }
                console.log(respo)
            }
            setIsUpdatingFields(false)
        }

        setTemplateVariableForCampaign()

    };

    const getTemplateVariableForCampaign = async () => {
        function extractTemplateSections(respo) {
            let header = {
                headerType: '',
                headerContent: ''
            };
            let body = {};
            let footer = {};

            respo.forEach(item => {
                const { varType, position, value } = item;

                if (varType === 'header' && position === '1') {
                    header.headerType = 'image'; // or 'text' if needed
                    header.headerContent = value;
                } else if (varType === 'body') {
                    body[`{{${position}}}`] = value;
                } else if (varType === 'footer' && position === '1') {
                    footer[position] = value;
                }
            });

            return { header, body, footer };
        }


        const response = await fetch(BASE_URL_API + "getTemplateVariableForCampaign",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    campaignIdentifier: campaignIdentifier,
                    templateIdentifier: template?.templateIdentifier
                })
            })

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                // setHeaderData(respo?.)
                const ets = extractTemplateSections(respo?.response)
                setHeaderData(ets['header'])
                setVariableValues(ets['body'])
                setFooterVariables(ets['footer'])
            } else {
                if (respo.message === "tokenExpired") {
                    authCtx.logout()
                }
            }
        }
    }

    const openImageSelector = async () => {
        setIsContentSelectorOpen(true)
    }

    const closeContentSelector = async () => {
        setIsContentSelectorOpen(false)
    }

    useEffect(() => {
        getTemplateVariableForCampaign()
    }, [template?.templateIdentifier])

    useEffect(() => {
        let varData = [
            { varType: 'header', position: 1, value: headerData?.headerContent }
        ];

        Object.entries(variableValues).forEach(([key, value]) => {
            const position = parseInt(key.replace(/[{}]/g, '')); // Extract number from {{1}}
            varData.push({ varType: 'body', position, value });
        });

        if (Object.entries(footerVariables)?.length > 0) {
            Object.entries(footerVariables).forEach(([key, value]) => {
                const position = parseInt(key); // Extract number from {{1}}
                varData.push({ varType: 'footer', position, value });
            });
        }

        setTemplateErrors(validateTemplateVars(varData))
    }, [headerData, variableValues, footerVariables])

    const selectImageHandler = (url) => {
        setHeaderData({ ...headerData, headerContent: url })
        setIsContentSelectorOpen(false)
    }


    if (!visible || !selectedTemplate) return null;

    return (
        <div className={styles.previewOverlay} onClick={handleOverlayClick}>
            <div className={styles.previewContent} onClick={handleContentClick}>
                <button className={styles.closeBtn} onClick={onClose}>
                    <AiOutlineClose />
                </button>
                {isContentSelectorOpen && <ContentSelector isOpen={isContentSelectorOpen} onClose={closeContentSelector} onSelect={selectImageHandler} /> }

                <div className={styles.layout}>
                    {/* Left Column: Fill Variables */}
                    <div className={styles.leftColumn}>
                        <h3 className={styles.title}>Fill Variables</h3>
                        <div>
                            {templateErrors?.status !== "success" ?
                                <div className={styles.errorWrapper}>
                                    <div className={styles.noParamsReady} onClick={() => setIsErrorOpen(!isErrorOpen)} >
                                        {templateErrors?.errors?.length} error found!
                                        {isErrorOpen === true ?
                                            <FaChevronDown size={14} />
                                            :
                                            <FaChevronUp size={14} />
                                        }
                                    </div>
                                    {isErrorOpen === true &&
                                        <div>
                                            <ul>
                                                {templateErrors?.errors?.map((itemErr, indexErr) => (
                                                    <li key={indexErr} >
                                                        <div className={styles.errTxt}>
                                                            {itemErr.error}
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    }
                                </div>
                                :
                                <div className={styles.errorWrapper}>
                                    <div className={styles.allParamsReady}>
                                        <FaCheck color="green" />
                                        All parameters are ready!
                                    </div>
                                </div>
                            }
                        </div>
                        {selectedTemplate?.headerType !== null &&
                            <div>
                                <div className={styles.sectionTitle}>
                                    Header
                                </div>
                                <div>
                                    {headerData?.headerType === "text" &&
                                        <div>
                                            <input />
                                        </div>
                                    }
                                    {headerData?.headerType === "image" &&
                                        <div className={styles.headerInput}>
                                            <input placeholder="Please enter image URL"
                                                value={headerData?.headerContent}
                                                onChange={(e) => setHeaderData({ ...headerData, headerContent: e.target.value })}
                                                readOnly
                                            />
                                            <button onClick={() => openImageSelector()} >Select</button>
                                        </div>
                                    }
                                    {headerData?.headerType === "video" &&
                                        <div>
                                            <input />
                                        </div>
                                    }
                                </div>
                            </div>
                        }

                        <div>
                            <div className={styles.sectionTitle}>
                                Body
                            </div>

                            <div className={styles.variablesContainer}>
                                {variables.length === 0 ? (
                                    <p>No variables found in the template.</p>
                                ) : (
                                    variables.map((item, index) => (
                                        <div className={styles.variableRow} key={index}>
                                            <div className={styles.dropdown} >
                                                <select onChange={(e) => variableSelectorHandler(item, e.target.value)}>
                                                    <option>Enter</option>
                                                    {predefinedParams?.map((itemParam, indexParam) => (
                                                        <option key={indexParam} value={itemParam?.identifier}>
                                                            {itemParam?.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className={styles.inputRow}>
                                                <input
                                                    className={styles.variableInput}
                                                    placeholder={`Enter value for ${item}`}
                                                    value={variableValues[item] || ""}
                                                    onChange={(e) => handleVariableChange(item, e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                            {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
                        </div>
                        <div>
                            <div className={styles.sectionTitle}>Footer</div>
                            {selectedTemplate?.footer_var_1 !== null &&
                                <div className={styles.variableRow}>
                                    <div className={styles.dropdown} >
                                        <select onChange={(e) => footerSelectorHandler(1, e.target.value)}>
                                            <option>Enter</option>
                                            {predefinedParams?.map((itemParam, indexParam) => (
                                                <option key={indexParam} value={itemParam?.identifier}>
                                                    {itemParam?.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className={styles.inputRow}>
                                        <input
                                            className={styles.variableInput}
                                            placeholder={`Enter value for`}
                                            value={footerVariables[1] || ""}
                                            onChange={(e) => handleFooterVariableChange(1, e.target.value)}
                                        />
                                    </div>
                                </div>
                            }

                            {selectedTemplate?.footer_var_2 !== null &&
                                <div className={styles.variableRow}>
                                    <div className={styles.dropdown} >
                                        <select onChange={(e) => footerSelectorHandler(2, e.target.value)}>
                                            <option>Enter</option>
                                            {predefinedParams?.map((itemParam, indexParam) => (
                                                <option key={indexParam} value={itemParam?.identifier}>
                                                    {itemParam?.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className={styles.inputRow}>
                                        <input
                                            className={styles.variableInput}
                                            placeholder={`Enter value for`}
                                            value={footerVariables[2] || ""}
                                            onChange={(e) => handleFooterVariableChange(2, e.target.value)}
                                        />
                                    </div>
                                </div>
                            }

                        </div>
                        <div className={styles.actionWrapper}>
                            {isUpdatingFields === true ?
                                <button className={styles.updateBtn} disabled >
                                    Updating...
                                </button>
                                :
                                <button className={styles.updateBtn} onClick={() => submissionHandler()} >
                                    Update Field
                                </button>
                            }
                            <button className={styles.selectButton} onClick={handleSelectTemplate}>
                                <MdOutlineMessage />
                                Select Template
                            </button>
                        </div>

                    </div>

                    {/* Right Column: Preview */}
                    <div className={styles.rightColumn}>
                        <h3 className={styles.title}>Message Preview</h3>
                        <TemplatePreviewWhatsApp headerData={headerData} previewText={previewText} />



                    </div>
                </div>
            </div>
        </div>
    );
};

export default TemplatePreview;
